import React from "react";

const ArrowLeft = ({ color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 4.94121L8.25 12L15.75 19.0589L14.25 21.8824L3.75 12L14.25 2.11768L15.75 4.94121Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowLeft;
